// Contenido por defecto de la landing = los constantes "baked" en el bundle.
// Sirve de FALLBACK: si /content.json no está disponible o viene incompleto, la
// página se renderiza igual con estos datos. También define la FORMA que debe
// tener content.json (mismas claves de primer nivel).

import { navLinks } from "../constants/navLinks.js";
import { certificaciones } from "../constants/certificaciones.js";
import { homeAbout, awrapper, testimonal } from "../constants/dummydata.js";
import { academicDegrees, bachFeatures } from "../constants/educativeOfferData.js";
import { homeAboutHeading, awrapperHeading, hero, footer, locations, contact, bachillerato } from "../constants/siteText.js";

export const defaultContent = {
  navLinks,
  academicDegrees,
  bachFeatures,
  homeAbout,
  homeAboutHeading,
  awrapper,
  awrapperHeading,
  testimonal,
  certificaciones,
  locations,
  // Secciones "ficha" (objeto único) — textos sueltos editables:
  hero,
  footer,
  contact,
  bachillerato,
};

export const CONTENT_KEYS = Object.keys(defaultContent);
